import { render, staticRenderFns } from "./eval-detail-4.vue?vue&type=template&id=80774ffc&scoped=true"
import script from "./eval-detail-4.vue?vue&type=script&lang=js"
export * from "./eval-detail-4.vue?vue&type=script&lang=js"
import style0 from "./eval-detail-4.vue?vue&type=style&index=0&id=80774ffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80774ffc",
  null
  
)

export default component.exports